import { Injectable, inject } from '@angular/core';

import { TrackingService as VanillaTrackingService } from '@frontend/vanilla/core';

import { DataUpdateEvent, ErrorEvent, Event } from './vanilla-tracking-adapter.model';

@Injectable({ providedIn: 'root' })
export class VanillaTrackingAdapter {
    vanillaTrackingService = inject(VanillaTrackingService);

    trigger(event: Event) {
        this.vanillaTrackingService.triggerEvent(event.name, event.data);
    }

    reportError(event: ErrorEvent) {
        this.vanillaTrackingService.reportError(event.data);
    }

    update(event: DataUpdateEvent) {
        this.vanillaTrackingService.updateDataLayer(event.data);
    }
}
